import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  crop: {
    width: 30,
    overflow: 'hidden',
  },
  logo: {
    display: 'block',
    width: 'auto',
    maxWidth: 'none',
    height: 28,
  },
});

export const LogoIcon = () => {
  const classes = useStyles();

  return (
    <div className={classes.crop}>
      <img className={classes.logo} src="/neusix-logo.svg" alt="NeuSix" />
    </div>
  );
};
